<template>
  <div :class="row ? 'd-flex' : ''">
    <div class="ml-2 mb-2 label" :class="row ? 'label-row' : ''" v-if="labeltxt != null">
      <label v-html="htmlLabeltxt"></label>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SearchBox',
  props: {
    labeltxt: {
      type: [String],
    },
    required: {
      type: [Boolean],
      default: false,
    },
    row: {
      type: [Boolean],
      default: false,
    },
  },
  computed: {
    htmlLabeltxt() {
      return !this.isNullOrEmpty(this.labeltxt) ? `${this.labeltxt}：` : null;
    },
  },
};
</script>

<style lang="scss" scoped>

label {
  font-size: 1rem;
  word-break: break-all;
}

.label {

  @include pad-width() {
    min-height: 24px;;
  }
}

.label-row {
  min-width: 150px;
  text-align: end;

  @include pad-width() {
    min-height: 24px;;
  }
}
</style>
